import { render, staticRenderFns } from "./ArquivoUpload.vue?vue&type=template&id=5650bb56&scoped=true"
import script from "./ArquivoUpload.vue?vue&type=script&lang=js"
export * from "./ArquivoUpload.vue?vue&type=script&lang=js"
import style0 from "./ArquivoUpload.vue?vue&type=style&index=0&id=5650bb56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5650bb56",
  null
  
)

export default component.exports